import { CatchCoreModule } from './modules/catch-core/catch-core.module';
import { AlertComponent } from './components/general/dialog/alert/alert.component';
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/user/login/login.component';
import { HttpClient } from '@angular/common/http';
import { HeaderComponent } from './components/dashboard/header/header.component';
import { BlankComponent } from './components/dashboard/blank/blank.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DatePickerModule } from 'primeng/datepicker';
import { DateFormat } from './services/helpers/date.helper';
import { LoadingComponent } from './components/general/dialog/loading/loading.component';
import { DialogComponent } from './components/general/dialog/confirm/dialog.component';
import { SimpleNotificationsModule, NotificationsService } from 'angular2-notifications';
import { AppRoutingModule } from './app-routes';
import { RouterModule } from '@angular/router';
import { ProfileAndChangePasswordComponent } from './components/user/profile-and-change-password/profile-and-change-password.component';
import { UserProfileComponent } from './components/user/user-profile/user-profile.component';
import { ChangePasswordComponent } from './components/user/change-password/change-password.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { AnimalsDashboardComponent } from './components/dashboard/animals-dashboard/animals-dashboard.component';
import { JwtModule } from '@auth0/angular-jwt';
import { DetailComponent } from './components/detail/detail.component';
import { DateAdapter } from '@angular/material/core';
// import { OktaAuthModule, OktaCallbackComponent } from '@okta/okta-angular';
import { environment } from '../environments/environment';
import { SettingsTabComponent } from './components/settings/settings-tab/settings-tab.component';
import { ProjectsViewComponent } from './components/dashboard/projects-view/projects-view.component';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { BaseComponent } from './components/base/base.component';
import { PasswordUpdateComponent } from './components/user/password-update/password-update.component';
import { ExternalAnimalComponent } from './components/dashboard/external-animal/external-animal.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PerfHudComponent } from './perf/perf-hud.component';
import { PerfHttpInterceptor } from './perf/perf-http.interceptor';
import { ToolbarAppMenuComponent } from './components/dashboard/header/toolbar-app-menu/toolbar-app-menu.component';
import { ToolbarUserMenuComponent } from './components/dashboard/header/toolbar-user-menu/toolbar-user-menu.component';
import { ToolbarAppMenuIconComponent } from './components/dashboard/header/toolbar-app-menu/toolbar-app-menu-icon/toolbar-app-menu-icon.component';
import { AboutCatchComponent } from './components/user/about-catch/about-catch.component';
import { SignUpComponent } from './components/user/signup/signup.component';
// import { TreeModule } from '@circlon/angular-tree-component';
import { TreeModule } from 'primeng/tree';
import { CatchHubDashboardComponent } from './components/dashboard/catch-hub-dashboard.component';
import { ChatWindowComponent } from './components/widgets/chat-window/chat-window.component';
import { TestStepTableModule } from './modules/shared-edit-panel/modules/test-step-table/test-step-table.module';
import { CarouselModule } from 'primeng/carousel';
import { PasswordResetComponent } from './components/user/password-reset/password-reset.component';
import { CopilotConsentCompleteComponent } from './components/copilot-consent/copilot-consent-complete.component';
import { VideoListComponent } from './modules/catch-core/component/video-list/video-list.component';
import { ProjectAllocationComponent } from './components/dashboard/projects-view/project-allocation/project-allocation.component';
import { ProjectStatusComponent } from './components/dashboard/projects-view/project-status/project-status.component';
import { CurrentWorkingProjectComponent } from './components/dashboard/projects-view/current-working-project/current-working-project.component';
import { ProjectOwnerPipe } from './modules/catch-core/pipes/pipes/project-owner.pipe';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { DragDropModule } from 'primeng/dragdrop';
import { PrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import { TreeDragDropService, ConfirmationService } from 'primeng/api';
import { SharedEditPanelModule } from './modules/shared-edit-panel/shared-edit-panel.module';
import { ImportDialogComponent } from './components/import-dialog/import-dialog.component';
import { OrgImportDialogComponent } from './components/organization/org-import-dialog/org-import-dialog.component';
import { OrgExportDialogComponent } from './components/organization/org-export-dialog/org-export-dialog.component';
import { SharedHeaderComponent } from './components/dashboard/shared-header/shared-header.component';
import { CommonTopToolbarComponent } from './components/dashboard/shared-header/tool-bar/top-toolbar/common-top-toolbar/common-top-toolbar.component';
import { BottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/bottom-toolbar.component';
import { DoBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/do-bottom-toolbar/do-bottom-toolbar.component';
import { MapBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/map-bottom-toolbar/map-bottom-toolbar.component';
import { ReportBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/report-bottom-toolbar/report-bottom-toolbar.component';
import { TrackBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/track-bottom-toolbar/track-bottom-toolbar.component';
import { SharedHeaderFirstPanelComponent } from './components/dashboard/shared-header/shared-header-first-panel/shared-header-first-panel.component';
import { SharedHeaderSecondPanelComponent } from './components/dashboard/shared-header/shared-header-second-panel/shared-header-second-panel.component';
import { SharedHeaderThirdPanelComponent } from './components/dashboard/shared-header/shared-header-third-panel/shared-header-third-panel.component';
import { ProjectSelectorComponent } from './components/widgets/project-selector/project-selector.component';
import { DoTopToolbarComponent } from './components/dashboard/shared-header/tool-bar/top-toolbar/do-top-toolbar/do-top-toolbar.component';
import { ReportTopToolbarComponent } from './components/dashboard/shared-header/tool-bar/top-toolbar/report-top-toolbar/report-top-toolbar.component';
import { TimelineTopToolbarComponent } from './components/dashboard/shared-header/tool-bar/top-toolbar/timeline-top-toolbar/timeline-top-toolbar.component';
import { TrackTopToolbarComponent } from './components/dashboard/shared-header/tool-bar/top-toolbar/track-top-toolbar/track-top-toolbar.component';
import { LabelNameComponent } from './components/widgets/label-name/label-name.component';
import { CreateNodeComponent } from './components/widgets/create-node/create-node.component';
import { NodeTypeMenuComponent } from './components/widgets/node-type-menu/node-type-menu.component';
import { StatusPercentageComponent } from './components/widgets/status-percentage/status-percentage.component';
import { RollUpComponent } from './components/widgets/roll-up/roll-up.component';
import { ChatBotButtonComponent } from './components/widgets/chat-bot-button/chat-bot-button.component';
import { ReportExportPngComponent } from './components/widgets/report-export-png/report-export-png.component';
import { DoExportPdfComponent } from './components/widgets/do-export-pdf/do-export-pdf.component';
import { DoExportExcelComponent } from './components/widgets/do-export-excel/do-export-excel.component';
import { DoToggleExpandComponent } from './components/widgets/do-toggle-expand/do-toggle-expand.component';
import { TimelineToggleExpandComponent } from './components/widgets/timeline-toggle-expand/timeline-toggle-expand.component';
import { MapExportComponent } from './components/widgets/map-export/map-export.component';
import { TimelineExportComponent } from './components/widgets/timeline-export/timeline-export.component';
import { MapLayoutChangeComponent } from './components/widgets/map-layout-change/map-layout-change.component';
import { TimeLineViewTypeComponent } from './components/widgets/timeline-view-type/timeline-view-type.component';
import { TimelineBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/timeline-bottom-toolbar/timeline-bottom-toolbar.component';
import { PanelEdgeToggleComponent } from './components/dashboard/panel-edge-toggle/panel-edge-toggle.component';
import { SharedRightPanelHeaderComponent } from './components/dashboard/shared-right-panel-header/shared-right-panel-header/shared-right-panel-header.component';
import { StatusGraphComponent } from './components/widgets/status-graph/status-graph.component';
import { FilterToolbarModule } from './components/widgets/filter-toolbar/filter-toolbar.module';
import { TopToolbarComponent } from './components/dashboard/shared-header/tool-bar/top-toolbar/top-toolbar.component';
import { MapTopToolbarComponent } from './components/dashboard/shared-header/tool-bar/top-toolbar/map-top-toolbar/map-top-toolbar.component';
import { CommonBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/common-bottom-toolbar/common-bottom-toolbar.component';
import { DoColumnShowHideComponent } from './components/widgets/do-column-show-hide/do-column-show-hide.component';
import { DeleteItemButtonComponent } from './components/widgets/delete-item-button/delete-item-button.component';
import { CopyItemButtonComponent } from './components/widgets/copy-item-button/copy-item-button.component';
import { AgileBoardSortComponent } from './components/widgets/agile-board-sort/agile-board-sort.component';
import { AgileBoardColorOptionsComponent } from './components/widgets/agile-board-color-options/agile-board-color-options.component';
import { AgileBoardAddColumnComponent } from './components/widgets/agile-board-add-column/agile-board-add-column.component';
import { WikiExportPdfComponent } from './components/widgets/wiki-export-pdf/wiki-export-pdf.component';
import { WikiEditorBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/wiki-bottom-toolbar/wiki-bottom-toolbar/wiki-bottom-toolbar.component';
import { WikiTableBottomToolbarComponent } from './components/dashboard/shared-header/tool-bar/bottom-toolbar/wiki-table-bottom-toolbar/wiki-table-bottom-toolbar.component';

const config = {
  issuer: environment.okta_issuer,
  redirectUri: environment.okta_redirectUri,
  clientId: environment.okta_clientId,
  pkce: true,
};

const LaraBlue = definePreset(Lara, {
  // Swap emerald primary scale for the blue palette to match the legacy theme.
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});
export const MY_CUSTOM_FORMATS = {
  fullPickerInput: 'DD/MM/YYYY hh:mm A',
  parseInput: 'DD/MM/YYYY hh:mm A',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'hh:mm A',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

export function tokenGetter() {
  return localStorage.getItem('access_token');
}
@NgModule({
  declarations: [
    AppComponent,
    AboutCatchComponent,
    AlertComponent,
    AnimalsDashboardComponent,
    BaseComponent,
    BlankComponent,
    CatchHubDashboardComponent,
    ChatWindowComponent,
    ChangePasswordComponent,
    DialogComponent,
    DetailComponent,
    SharedRightPanelHeaderComponent,
    PanelEdgeToggleComponent,
    FeedbackComponent,
    HasPermissionDirective,
    HeaderComponent,
    LoadingComponent,
    LoginComponent,
    PasswordResetComponent,
    CopilotConsentCompleteComponent,
    PasswordUpdateComponent,
    ProfileAndChangePasswordComponent,
    ProjectsViewComponent,
    RollUpComponent,
    SettingsTabComponent,
    SignUpComponent,
    ToolbarAppMenuComponent,
    ToolbarAppMenuIconComponent,
    ToolbarUserMenuComponent,
    UserProfileComponent,
    CreateNodeComponent,
    VideoListComponent,
    ProjectOwnerPipe,
    ProjectAllocationComponent,
    ProjectStatusComponent,
    CurrentWorkingProjectComponent,
    ImportDialogComponent,
    OrgImportDialogComponent,
    OrgExportDialogComponent,
    SharedHeaderComponent,
    StatusGraphComponent,
    StatusPercentageComponent,
    ChatBotButtonComponent,
    LabelNameComponent,
    TopToolbarComponent,
    DoTopToolbarComponent,
    MapTopToolbarComponent,
    ReportTopToolbarComponent,
    TimelineTopToolbarComponent,
    TrackTopToolbarComponent,
    CommonTopToolbarComponent,
    BottomToolbarComponent,
    DoBottomToolbarComponent,
    WikiEditorBottomToolbarComponent,
    WikiTableBottomToolbarComponent,
    MapBottomToolbarComponent,
    ReportBottomToolbarComponent,
    TimelineBottomToolbarComponent,
    TrackBottomToolbarComponent,
    SharedHeaderFirstPanelComponent,
    SharedHeaderSecondPanelComponent,
    SharedHeaderThirdPanelComponent,
    ProjectSelectorComponent,
    ReportExportPngComponent,
    DoExportPdfComponent,
    WikiExportPdfComponent,
    DoExportExcelComponent,
    DoToggleExpandComponent,
    TimelineToggleExpandComponent,
    MapExportComponent,
    TimelineExportComponent,
    MapLayoutChangeComponent,
    TimeLineViewTypeComponent,
    CommonBottomToolbarComponent,
    DoColumnShowHideComponent,
    DeleteItemButtonComponent,
    CopyItemButtonComponent,
    AgileBoardSortComponent,
    AgileBoardColorOptionsComponent,
    AgileBoardAddColumnComponent,
  ],

  imports: [
    PerfHudComponent,
    NodeTypeMenuComponent,
    FilterToolbarModule,
    CatchCoreModule,
    SharedEditPanelModule,
    // BluePrintFieldAllocationTableModule,
    CarouselModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    DatePickerModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    TestStepTableModule,
    // ProgressHttpModule,
    TreeModule,
    ContextMenuModule,
    ToastModule,
    DragDropModule,
    CommonModule,
    AppRoutingModule,
    RouterModule,
    SimpleNotificationsModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ['localhost:55331'],
      },
    }),
  ],
  providers: [
    provideClientHydration(),
    CatchCoreModule,
    HttpClient,
    MessageService,
    TreeDragDropService,
    CatchHubDashboardComponent,
    LoadingComponent,
    DialogComponent,
    AnimalsDashboardComponent,
    NotificationsService,
    { provide: DateAdapter, useClass: DateFormat },
    ConfirmationService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: PerfHttpInterceptor, multi: true },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    private dateAdapter: DateAdapter<any>,
    primeng: PrimeNG,
  ) {
    primeng.setConfig({
      theme: { preset: LaraBlue },
    });
  }
}
